/*
 * patient-form (schema)
 */
import { boolean, integer, jsonb, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { forms } from "../form/form.schema"
import { users } from "../user/user.schema"

export const patientForms = schema.table("patient_forms", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id").notNull().references(() => patients.id, { onDelete: "cascade" }),
	formId: uuid("form_id").notNull().references(() => forms.id, { onDelete: "restrict" }),

	// --- State ---
	status: varchar("status", { length: 32 }).notNull().default("assigned"), // assigned | in_progress | completed
	responses: jsonb("responses"), // Record<questionKey, value>
	score: integer("score"), // calculated total score on submit
	completedAt: timestamp("completed_at", { withTimezone: true }),
	assignedBy: uuid("assigned_by").references(() => users.id, { onDelete: "set null" }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
